/* Pulled in from SearchUI for search suggestions */

import React, { ReactNode } from 'react';

interface Props {
  /** Header content - Search */
  header: ReactNode;
}

const Layout = ({ header }: Props) => {
  return (
    <div className="sui-layout">
      <div className="sui-layout-header">
        <div className="sui-layout-header__inner">{header}</div>
      </div>
    </div>
  );
};

export default Layout;
